module.exports = __webpack_public_path__ + "static/media/ts4cr73.63a4c4b4.png";